export const analyticsUserIdField = 'https://danfoss.com/analytics_user_id';

type User = {
  [analyticsUserIdField]: string;
}

export const pushEvent = (eventObject: object, user?: User | null) => {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(user ? { ...eventObject, 'userId': user[analyticsUserIdField] } : eventObject);
}
